import React, { useState, useContext, useEffect, useRef } from 'react'
import InputBase from '@mui/material/InputBase';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { DropzoneArea } from 'react-mui-dropzone'

import { Editor } from '@tinymce/tinymce-react';

import { ListingContext } from '../../contexts/ListingContext';
import { OperatorContext } from '../../contexts/OperatorContext';
import { OptionsContext } from '../../contexts/OptionsContext';


import { UseUrlHandler } from '../../helpers/handleUrlLink'
import formatUrlTitle from '../../helpers/formatUrlTitle';
import { uploadImages } from '../../helpers/uploadImages'
import { geocodeAddress, locationPayload, GEOCODE_FAILED_NOTICE } from '../../helpers/geocode'
import Loader from '../Loader'

import './CMSForm.css'
window.Buffer = window.Buffer || require("buffer").Buffer;

const maxFormSection = 6


const stateNames = [
    'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut',
    'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas',
    'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota',
    'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey',
    'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon',
    'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah',
    'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
];

const CMSForm = ({ closeForm, initialData, onSave, searchString, page }) => {
    const { care, clinical, beds, amenities, insurance } = useContext(OptionsContext)
    const { createListing, editListing } = useContext(ListingContext)
    const { getAllOperators } = useContext(OperatorContext)

    const editorRef = useRef(null);

    const [allOperators, setAllOperators] = useState([])

    const [currSectionPass, setCurrSectionPass] = useState(false)
    const [formSection, setFormSection] = useState(1)
    const [inputData, setInputData] = useState({
        name: '',
        operator: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        phone: '',
        email: '',
        emails: [],
        website_url: '',
        // rating: null,
        long_description: '',
        // private_beds: null,
        // semiprivate_beds: null,
        // total_beds: null,
        bed_types: [],
        // pet_friendly: null,
        // smoke_friendly: null,
        contact_name: '',
        insurance: [],
        capabilities: [],
        amenities: [],
        care: [],
        request_info_email: '',
        tour_urls: [''],
        tour_urls_order: [0],
        images: [],
        // images_order: [0],
        brochure_image: {},
        published: false,
        listing_logo: '',
        listing_color_primary: '',
        listing_color_secondary: '',
        bed_availability: [],
        
    })

    const [clearAllImages, setClearAllImages] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [error, setError] = useState('')
    // Set after a successful save that could not be geocoded; holds the form open.
    const [notice, setNotice] = useState('')

    const capabilitiesArr = clinical.map(e => e.option)
    const insurances = insurance.map(e => e.option)
    const amenitiesArr = amenities.map(e => e.option)
    const careArr = care.map(e => e.option)
    const bedsArr = beds.map(e => e.option)

    const [sectionCheck, setSectionCheck] = useState({
        section1Filled: false,
        section2Filled: false,
        section3Filled: false,
        section4Filled: false,
    })

    useEffect(() => {
        getAllOperators(1, null, 'all').then((data) => { if (data) setAllOperators(data) })
    }, [])

    useEffect(() => {
        if (initialData && Object.keys(initialData).length > 0) {
            let selectedOperator = allOperators.find(e => String(e._id) === String(initialData.organization_id))
            let tourArr = (initialData.tour_urls || []).map(e => e.url.trim())
            let tourArrOrder = (initialData.tour_urls || []).map(e => e.order || 0)
            let insurances = (initialData.insurance || []).map(e => e.provider.trim())
            let capabilities = (initialData.capabilities || []).map(e => e.capability.trim())
            let amenities = (initialData.amenities || []).map(e => e.amenity.trim())
            let care = (initialData.care || []).map(e => e.offering.trim())
            let bed_types = (initialData.bed_types || []).map(e => e.option.trim())
            let emails = (initialData.emails || []).map(e => e.address.trim())
            let brochure_image = initialData.brochure_image ? { name: initialData.brochure_image } : {}
            let listing_color = initialData.listing_color && JSON.parse(initialData.listing_color)
            let listing_logo = initialData.listing_logo ? { name: initialData.listing_logo } : {}

            const assignOrder = (arr) => {
                const maxOrder = arr.length
                let newArr = arr.filter(e => e.order === null).map((e, i) => { return { ...e, order: maxOrder + i + 1 } })
                return [...arr.filter(e => e.order !== null), ...newArr].sort((a, b) => a.order - b.order).map((e, i) => { return { ...e, order: i + 1 } })
            }

            let images = assignOrder([
                ...(initialData.images || []).map(e => { return { name: e.name ? e.name : null, url: e.url, remove: e.remove ? e.remove : null, _id: null, order: e.order ? e.order : null } }),
            ].filter(e => e.url).sort((a, b) => a.order - b.order))

            setInputData({
                ...initialData,
                operator: String(selectedOperator?._id || initialData.organization_id || ''),
                tour_urls: tourArr,
                tour_urls_order: tourArrOrder,
                insurance: insurances,
                amenities: amenities,
                care: care,
                bed_types: bed_types,
                capabilities: capabilities,
                images: images,
                emails: emails ? emails : [],
                brochure_image: brochure_image,
                listing_color_primary: listing_color && listing_color.primary ? listing_color.primary : '',
                listing_color_secondary: listing_color && listing_color.secondary ? listing_color.secondary : '',
                listing_logo: listing_logo,
                bed_availability: (initialData.bed_availability || []).map(item => ({
                    date: item.available_date || item.date,
                    beds: item.data || item.beds || {},
                }))
            })
        }
    }, [initialData])

    // No operator-catalog sync effect is needed: the [initialData] effect above already
    // falls back to initialData.organization_id, which is the same id the catalog would
    // resolve to, so `operator` is correct even when allOperators loads later.

    useEffect(() => {
        updateSectionPass()
    }, [inputData])

    function handleChange(e) {
        const { name, value } = e.target;

        setInputData({
            ...inputData,
            [name]: value,
        });

    }

    function handleToggleChange(e) {
        const { name, checked } = e.target;

        setInputData({
            ...inputData,
            [name]: checked,
        });

    }

    function handleCloseForm(e) {
        // mousedown (not click): a failed save unmounts the spinner under the cursor,
        // and the leftover click would otherwise hit this overlay and dismiss the form.
        if (isSubmitting) return
        if (e.target === e.currentTarget) closeForm()
    }

    async function handleClick() {
        if (updateSectionPass()) {
            if (formSection !== maxFormSection) {
                setFormSection(formSection + 1)
            }
            else {
                setIsSubmitting(true)
                setError('')
                try {
                    // null when the address can't be geocoded — never blocks the save.
                    let locationData = await geocodeAddress(inputData)

                    let newImages = inputData.images.filter(e => e.file)
                    let urls = newImages?.length > 0 ? await uploadImages(newImages) : []
                    let currUrls = inputData.images && initialData?.images?.length > 0 ? inputData.images.filter(e => !e.remove) : []

                    // Apply assignOrder logic to ensure proper ordering of images
                    const assignOrder = (arr) => {
                        const maxOrder = arr.length
                        const newArr = arr.filter(e => e.order === null).map((e, i) => { return { ...e, order: maxOrder + i + 1 } })
                        return [...arr.filter(e => e.order !== null), ...newArr].sort((a, b) => a.order - b.order).map((e, i) => { return { ...e, order: i + 1 } })
                    }

                    // Combine and normalize image data structures
                    const combinedImages = [
                        ...urls.map(e => ({ url: e.url, order: e.order || null })),
                        ...currUrls.map(e => ({ url: e.url, order: e.order || null }))
                    ].filter(e => e.url)

                    const updatedImages = assignOrder(combinedImages)


                    let tourArr = inputData.tour_urls.filter(e => e !== '').map((e, i) => { return { url: e, order: inputData.tour_urls_order[i] } })

                    let amenities = inputData.amenities.filter(e => amenitiesArr.indexOf(e) !== -1).map(e => { return { amenity: e } })
                    let capabilities = inputData.capabilities.filter(e => capabilitiesArr.indexOf(e) !== -1).map(e => { return { capability: e } })
                    let insuranceArr = inputData.insurance.filter(e => insurances.indexOf(e) !== -1).map(e => { return { provider: e } })
                    let careSelected = inputData.care.filter(e => careArr.indexOf(e) !== -1).map(e => { return { offering: e } })
                    let bedTypesSelected = inputData.bed_types.filter(e => bedsArr.indexOf(e) !== -1).map(e => { return { option: e } })

                    let emails = inputData.emails.filter(e => e !== '').map(e => { return { address: e } })

                    let brochure_image = inputData?.brochure_image && inputData.brochure_image instanceof File ? await uploadImages([{ file: inputData.brochure_image, name: inputData.brochure_image.name }]) : initialData?.brochure_image ? initialData.brochure_image : null
                    let listing_logo = inputData?.listing_logo && inputData.listing_logo instanceof File ? await uploadImages([{ file: inputData.listing_logo, name: inputData.listing_logo.name }]) : initialData?.listing_logo ? initialData.listing_logo : null

                    let url_title = formatUrlTitle(inputData.name.trim())

                    let data = {
                        ...inputData,
                        long_description: editorRef.current.getContent(),
                        // location/formatted_address are omitted when geocoding failed.
                        // 'lat-long' matches how listings are already stored and queried.
                        ...locationPayload(locationData, { coordinateOrder: 'lat-long' })
                        , images: clearAllImages ? [] : updatedImages
                        , tour_urls: tourArr
                        , organization_id: inputData.operator || null
                        , insurance: insuranceArr
                        , capabilities: capabilities
                        , amenities: amenities
                        , care: careSelected
                        , bed_types: bedTypesSelected
                        , emails: emails
                        , brochure_image: typeof brochure_image === 'string' ? brochure_image : brochure_image ? brochure_image[0].url : null
                        , url_title: url_title
                        , listing_color: JSON.stringify({ primary: inputData.listing_color_primary, secondary: inputData.listing_color_secondary })
                        , listing_logo: typeof listing_logo === 'string' ? listing_logo : listing_logo ? listing_logo[0].url : null
                        , bed_availability: inputData.bed_availability.map(item => ({ available_date: item.date, data: item.beds }))
                    }
                    delete data.operator
                    delete data.listing_color_primary
                    delete data.listing_color_secondary

                    if (initialData && Object.keys(initialData).length > 0) {
                        await editListing(initialData._id, data, searchString, page)
                    } else {
                        await createListing(data, searchString)
                    }

                    // Saved either way. Hold the form open only to report the missing
                    // coordinates — the list behind it has already been refreshed.
                    if (!locationData) {
                        setNotice(GEOCODE_FAILED_NOTICE)
                        return
                    }

                    if (onSave) {
                        onSave()
                    } else {
                        closeForm()
                    }
                } catch (error) {
                    console.error('Error submitting form:', error)
                    const errorData = error.response?.data
                    setError(
                        errorData?.errors?.length
                            ? errorData.errors.join(' ')
                            : errorData?.msg || errorData?.message || errorData?.error || (typeof errorData === 'string' ? errorData : 'Failed to save listing.')
                    )
                } finally {
                    setIsSubmitting(false)
                }
            }
        }
    }

    function updateSectionPass() {
        let pass = false

        if (formSection === 1) {
            if (
                inputData.name !== '' &&
                inputData.address !== '' &&
                inputData.city !== '' &&
                inputData.state !== '' &&
                inputData.zip !== '' &&
                // inputData.phone !== '' &&
                emailCheck(inputData.email)
            ) {
                pass = true
                setCurrSectionPass(true)
                setSectionCheck({ ...sectionCheck, section1Filled: true })
            } else {
                setCurrSectionPass(false)
                setSectionCheck({ ...sectionCheck, section1Filled: false })
            }
        }
        else {
            pass = true
            setCurrSectionPass(true)
            setSectionCheck({ ...sectionCheck, [`section${formSection}Filled`]: true })
        }

        return pass
    }

    function emailCheck(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    function addInput(e, newElem, hasOrder) {
        const { name } = e.target;

        if (hasOrder) {
            setInputData({
                ...inputData,
                [name]: [...inputData[name], newElem],
                [`${name}_order`]: [...inputData[`${name}_order`], 0],
            });
        }
        else {
            setInputData({
                ...inputData,
                [name]: [...inputData[name], newElem]
            });
        }
    }

    function handleURLChange(e, index) {
        const { name } = e.target

        let arr = [...inputData[name]]
        arr[index] = e.target.value
        setInputData({
            ...inputData,
            [name]: arr,
        });
    }

    function handleImgChange(e, index) {
        const newImages = e.filter(e => {
            const found = inputData.images.find(el => el?.file?.name === e.name)
            return !found
        }).map((e, i) => {
            return {
                name: e.name, url: null, file: e, remove: false, _id: null, order: inputData.images.length + 1 + i
            }
        })

        setInputData({
            ...inputData,
            images: [...inputData.images, ...newImages],
        });
    }

    function handleImgOrderChange(currIndex, index) {
        let arr = inputData.images.map(e => {
            return {
                ...e,
                order:
                    currIndex > index ? (
                        e.order < parseInt(index) ? e.order
                            : e.order === parseInt(currIndex) ? parseInt(index)
                                : e.order >= parseInt(index) && e.order < parseInt(currIndex) ? e.order + 1
                                    : e.order
                    ) : (
                        e.order > parseInt(index) ? e.order
                            : e.order === parseInt(currIndex) ? parseInt(index)
                                : e.order <= parseInt(index) && e.order > parseInt(currIndex) ? e.order - 1
                                    : e.order
                    )
            }
        })

        setInputData({
            ...inputData,
            images: arr,
        });
    }

    function handleRemoveImg(e, index) {
        let arr = [...inputData.images]
        let selected = arr[index]
        arr[index] = { ...selected, remove: e.target.checked }

        setInputData({
            ...inputData,
            images: arr,
        });
    }

    function handleBrochureImgChange(e) {
        setInputData({
            ...inputData,
            brochure_image: e.target.files[0],
        });
    }

    function handleListingLogoChange(e) {
        setInputData({
            ...inputData,
            listing_logo: e.target.files[0],
        });
    }

    function addEmailInput(e, newElem) {
        const { name } = e.target;
        setInputData({
            ...inputData,
            [name]: [...inputData[name], newElem],
        });
    }

    function handleEmailChange(e, index) {
        let arr = [...inputData.emails]
        arr[index] = e.target.value
        setInputData({
            ...inputData,
            emails: arr,
        });
    }

    return (
        <div onMouseDown={handleCloseForm} className="modal-overlay">
            <div className="manage-facility-form" style={{ display: 'flex', flexDirection: 'column', height: '90vh' }}>
                {/* Tab Navigator */}
                <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Box sx={{ flex: '1 1 0', minWidth: 0 }}>
                    <Tabs
                      value={formSection - 1}
                      onChange={(e, newValue) => setFormSection(newValue + 1)}
                      variant="scrollable"
                      scrollButtons="auto"
                      allowScrollButtonsMobile
                    >
                      <Tab label="Basic Info" />
                      <Tab label="3D Tours" />
                      <Tab label="Images" />
                      <Tab label="Emails" />
                      <Tab label="Bed Availability" />
                      <Tab label="Other" />
                    </Tabs>
                  </Box>
                  <Button
                    variant="contained"
                    color="primary"
                    className='manger-facility-btn'
                    size="small"
                    sx={{ minWidth: 80 }}
                    disabled={!currSectionPass || isSubmitting}
                    onClick={handleClick}
                  >
                    {isSubmitting ? 'Submitting...' : 'Submit'}
                  </Button>
                </Box>
                {formSection === 1 ?
                    <FormSection1
                        inputData={inputData}
                        handleChange={(e) => { handleChange(e) }}
                        operators={allOperators}
                    />
                    : formSection === 2 ?
                        <FormSection2
                            inputData={inputData}
                            handleURLChange={(e, index) => { handleURLChange(e, index) }}
                            addInput={addInput}
                        />
                        : formSection === 3 ?
                            <FormSection3
                                inputData={inputData}
                                handleImgChange={(e, index) => { handleImgChange(e, index) }}
                                handleImgOrderChange={(currIndex, index) => { handleImgOrderChange(currIndex, index) }}
                                handleRemoveImg={(e, index) => { handleRemoveImg(e, index) }}
                                clearAllImages={() => {
                                    setInputData({ ...inputData, images: [] })
                                    setClearAllImages(!clearAllImages)
                                }}
                            // resetImages={() => setInputData({ ...inputData, images: initialData.images })}
                            />
                            : formSection === 4 ?
                                <FormSection4
                                    inputData={inputData}
                                    handleURLChange={(e, index) => { handleEmailChange(e, index) }}
                                    addInput={addEmailInput}
                                />
                                : formSection === 5 ?
                                    <FormSection5
                                        inputData={inputData}
                                        setInputData={setInputData}
                                    />
                                    :
                                    <FormSection6
                                        inputData={inputData}
                                        handleChange={(e) => { handleChange(e) }}
                                        handleToggleChange={(e) => { handleToggleChange(e) }}
                                        handleBrochureImgChange={(e) => { handleBrochureImgChange(e) }}
                                        handleListingLogoChange={(e) => { handleListingLogoChange(e) }}
                                        editorRef={editorRef}
                                    />
                }
                {error && <p style={{ textAlign: 'center', margin: '5px 0px', color: '#E23844' }}>{error}</p>}
                {notice && <p style={{ textAlign: 'center', margin: '5px 0px', color: '#B26A00' }}>{notice}</p>}
                {/* Bottom navigation buttons */}
                <Box sx={{ mt: 'auto', pt: 2, pb: 2, display: 'flex', justifyContent: 'center', gap: 2 }}>
                  {notice ? (
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => (onSave ? onSave() : closeForm())}
                    >
                      Close
                    </Button>
                  ) : (
                    <>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => setFormSection(formSection - 1)}
                        disabled={formSection === 1}
                      >
                        Back
                      </Button>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={() => {
                            formSection === maxFormSection ? handleClick() : setFormSection(formSection + 1)
                        }}
                        disabled={!currSectionPass || isSubmitting}
                      >
                        {formSection === maxFormSection ? (isSubmitting ? 'Submitting...' : 'Submit') : 'Next'}
                      </Button>
                    </>
                  )}
                </Box>
            </div>
            
            {/* Loading Overlay */}
            {isSubmitting && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999,
                    flexDirection: 'column',
                    gap: '20px'
                }}>
                    <Loader loading={true} height={60} />
                    <div style={{ color: 'white', fontSize: '18px', fontWeight: 'bold' }}>
                        Submitting form...
                    </div>
                </div>
            )}
        </div>
    )
}

export default CMSForm



const FormSection1 = ({ inputData, handleChange, operators }) => {
    return <>
        <h3 className="manage-facility-form-title">Create Listing</h3>
        <label htmlFor="name">Name</label>
        <InputBase className='manger-facility-input' value={inputData.name} onChange={(e) => handleChange(e)} type="text" name="name" id="name" placeholder='Name' />

        <label htmlFor="state">Operator</label>
        <FormControl fullWidth>
            <Select
                className="manger-facility-input"
                value={inputData.operator}
                name="operator"
                onChange={(e) => handleChange(e)}
            >
                <MenuItem value=""><em>None</em></MenuItem>
                {operators.sort((a, b) => { return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 0 }).map(e => <MenuItem key={String(e._id)} value={String(e._id)}>{e.name}</MenuItem>)}
            </Select>
        </FormControl>

        <label htmlFor="address">Address</label>
        <InputBase className='manger-facility-input' value={inputData.address} onChange={(e) => handleChange(e)} type="text" name="address" id="address" placeholder='Address' />

        <label htmlFor="city">City</label>
        <InputBase className='manger-facility-input' value={inputData.city} onChange={(e) => handleChange(e)} type="text" name="city" id="city" placeholder='City' />

        <label htmlFor="state">State</label>
        <FormControl fullWidth>
            <Select
                className="manger-facility-input"
                value={inputData.state}
                name="state"
                id="state"
                onChange={(e) => handleChange(e)}
            >
                {stateNames.map(e => <MenuItem key={e} value={e}>{e}</MenuItem>)}
            </Select>
        </FormControl>

        <label htmlFor="zip">Zip</label>
        <InputBase className='manger-facility-input' value={inputData.zip} onChange={(e) => handleChange(e)} type="text" name="zip" id="zip" placeholder='Zip' />

        <label htmlFor="phone">Phone</label>
        <InputBase className='manger-facility-input' value={inputData.phone} onChange={(e) => handleChange(e)} type="text" name="phone" id="phone" placeholder='Phone' />

        <label htmlFor="email">Email</label>
        <InputBase className='manger-facility-input' value={inputData.email} onChange={(e) => handleChange(e)} type="email" name="email" id="email" placeholder='Email' />

        <label htmlFor="website_url">Website</label>
        <InputBase className='manger-facility-input' value={inputData.website_url} onChange={(e) => handleChange(e)} type="text" name="website_url" id="website_url" placeholder='website' />

        <label htmlFor="website_url">CCN</label>
        <InputBase className='manger-facility-input' value={inputData.CCN} onChange={(e) => handleChange(e)} type="text" name="CCN" id="CCN" placeholder='ccn' />
    </>
}


const FormSection2 = ({ inputData, addInput, handleURLChange }) => {
    return <>
        <h3 className="manage-facility-form-title">Add 3d Tour Links</h3>
        <label htmlFor="3d-link">Add 3D Link</label>
        <button name='tour_urls' onClick={(e) => addInput(e, "", true)}>Add Another Link</button>
        {inputData.tour_urls.map((string, index) => {
            return <div style={{ display: 'flex', gap: 10 }}>
                <InputBase name='tour_urls' value={string} key={index} onChange={(e) => handleURLChange(e, index)} className='manger-facility-input' />
                <div style={{ width: '80px' }}>
                    <FormControl fullWidth>
                        <Select
                            className="manger-facility-input"
                            value={inputData.tour_urls_order[index]}
                            name="tour_urls_order"
                            onChange={(e) => handleURLChange(e, index)}
                        >
                            {inputData.tour_urls_order.map((e, i) => <MenuItem key={i} value={i}>{i}</MenuItem>)}
                        </Select>
                    </FormControl>
                </div>
            </div>
        })}
    </>
}

const FormSection3 = ({ inputData, handleImgChange, handleRemoveImg, handleImgOrderChange, clearAllImages }) => {
    return <>
        <h3 className="manage-facility-form-title" style={{ marginBottom: 20 }}>Add Images</h3>

        <DropzoneArea
            acceptedFiles={['image/jpeg', 'image/png']}
            showPreviews={false}
            showPreviewsInDropzone={false}
            maxFileSize={5000000}
            filesLimit={50}
            onChange={(e) => handleImgChange(e)}
        />

        <Button style={{ marginTop: 20, marginBottom: 20, width: '50%' }} variant="contained" disabled={inputData.images.length === 0} onClick={() => { clearAllImages() }}>Clear All</Button>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, width: '100%', marginTop: 20, marginBottom: 20 }}>
            {inputData.images.sort((a, b) => a.order - b.order).map((img, index) =>
                <div style={{ display: 'flex', width: '100%', gap: 10, justifyContent: 'space-between' }}>
                    <img alt="uploaded" style={{ width: '140px', height: '140px', objectFit: 'cover' }} src={img.url ? UseUrlHandler(img.url) : img.file ? URL.createObjectURL(img.file) : "#"} />
                    {img.url &&
                        <div>
                            <input style={{ marginLeft: 10 }} onChange={(e) => handleRemoveImg(e, index)} type="checkbox" id="currImage" name="currImage" checked={img.remove} />
                            <label for="currImage"> Check to Delete</label>
                        </div>
                    }
                    <div style={{ width: '80px' }}>
                        <FormControl fullWidth>
                            <Select
                                className="manger-facility-input"
                                value={parseInt(img.order)}
                                name="image_order"
                                onChange={(e) => handleImgOrderChange(img.order, e.target.value)}
                            >
                                {inputData.images.map((e, i) => <MenuItem key={i + 1} value={i + 1}>{i + 1}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </div>
                </div>
            )}
        </div>

    </>
}

const FormSection4 = ({ inputData, addInput, handleURLChange }) => {
    return <>
        <h3 className="manage-facility-form-title">Add Emails Addresses</h3>
        <label htmlFor="3d-link">Add Emails</label>
        <button name='emails' onClick={(e) => addInput(e, "")}>Add Email</button>
        {inputData.emails.map((string, index) => {
            return <>
                <InputBase value={string} key={index} onChange={(e) => handleURLChange(e, index)} className='manger-facility-input' />
            </>
        })}
    </>
}

const bedTypes = [
    { label: 'Short Term Rehab', gender: 'FEMALE' },
    { label: 'Long Term Care', gender: 'FEMALE' },
    { label: 'Short Term Rehab', gender: 'MALE' },
    { label: 'Long Term Care', gender: 'MALE' },
    { label: 'Isolation', gender: null },
    { label: 'Private', gender: null },
];

const FormSection5 = ({ inputData, setInputData }) => {
    const [displayDates, setDisplayDates] = useState([]);
    const [availability, setAvailability] = useState([]);
    const [lastUpdatedData, setLastUpdatedData] = useState(null);
    const [showLastUpdatedCol, setShowLastUpdatedCol] = useState(false);

    const toDay = (d) => {
        if (typeof d === 'string' && /^\d{4}-\d{2}-\d{2}/.test(d)) {
            const [y, m, day] = d.slice(0, 10).split('-').map(Number);
            return new Date(y, m - 1, day).getTime();
        }
        const x = new Date(d);
        x.setHours(0, 0, 0, 0);
        return x.getTime();
    };

    useEffect(() => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const pastAvailability = inputData.bed_availability
            ?.map(day => ({ ...day, date: new Date(toDay(day.date)) }))
            .filter(day => day.date < today)
            .sort((a, b) => b.date.getTime() - a.date.getTime());

        const lastUpdated = pastAvailability && pastAvailability.length > 0 ? pastAvailability[0] : null;
        setLastUpdatedData(lastUpdated);

        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        const dayAfterTomorrow = new Date(today);
        dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 2);
        const threeDays = [today, tomorrow, dayAfterTomorrow];

        const currentAvailabilityData = inputData.bed_availability?.filter(day => {
            return threeDays.some(d => d.getTime() === toDay(day.date));
        }) || [];

        const hasCurrentData = currentAvailabilityData.some(day =>
            Object.values(day.beds).some(val => val && Number(val) > 0)
        );

        const shouldShowLastUpdated = !!(lastUpdated && !hasCurrentData);
        setShowLastUpdatedCol(shouldShowLastUpdated);

        if (shouldShowLastUpdated && lastUpdated) {
            setDisplayDates([new Date(lastUpdated.date), ...threeDays]);
        } else {
            setDisplayDates(threeDays);
        }

        const availabilityForThreeDays = threeDays.map(date => {
            const existingDayData = currentAvailabilityData.find(day => toDay(day.date) === date.getTime());

            if (existingDayData) {
                return existingDayData;
            }

            return { date, beds: {} };
        });
        setAvailability(availabilityForThreeDays);
    }, [inputData.bed_availability]);

    const handleInputChange = (bedTypeKey, dateIndex, value) => {
        const availabilityIndex = showLastUpdatedCol ? dateIndex - 1 : dateIndex;
        if (availabilityIndex < 0) return;

        const newAvailability = [...availability];
        if (newAvailability[availabilityIndex]) {
            const parsedValue = parseInt(value, 10);
            newAvailability[availabilityIndex] = {
                ...newAvailability[availabilityIndex],
                beds: {
                    ...newAvailability[availabilityIndex].beds,
                    [bedTypeKey]: isNaN(parsedValue) ? '' : parsedValue,
                },
            };
            setAvailability(newAvailability);
            const editedDay = newAvailability[availabilityIndex];
            const storedBeds = { ...((inputData.bed_availability || []).find((day) => toDay(day.date) === toDay(editedDay.date))?.beds || {}) };
            if (isNaN(parsedValue)) delete storedBeds[bedTypeKey];
            else storedBeds[bedTypeKey] = parsedValue;
            setInputData({
                ...inputData,
                bed_availability: [
                    ...(inputData.bed_availability || []).filter((day) => toDay(day.date) !== toDay(editedDay.date)),
                    ...(Object.keys(storedBeds).length ? [{ ...editedDay, beds: storedBeds }] : []),
                ],
            });
        }
    };

    const handleClearHistory = () => {
        if (inputData.bed_availability && inputData.bed_availability.length > 0) {
            const todayMs = toDay(new Date());
            const filteredAvailability = inputData.bed_availability.filter(day => toDay(day.date) >= todayMs);
            setInputData({ ...inputData, bed_availability: filteredAvailability });
        }
    };

    const getBedTypeKey = (bed) => {
        return bed.gender ? `${bed.label} (${bed.gender})` : bed.label;
    };

    const formatDate = (date) => {
        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        return `${days[date.getDay()]} ${date.getMonth() + 1}/${date.getDate()}`;
    };

    return (
        <div style={{ width: '100%', overflowX: 'auto' }}>
            <h3 className="manage-facility-form-title">Manage Bed Availability</h3>
            <div style={{
                display: 'grid',
                gridTemplateColumns: `repeat(${displayDates.length + 1}, 1fr)`,
                gap: '10px',
                minWidth: '600px'
            }}>
                <div style={{ padding: '10px' }}>
                    {inputData.bed_availability && inputData.bed_availability.length > 0 && (
                        <button
                            onClick={handleClearHistory}
                            style={{
                                padding: '5px 10px',
                                backgroundColor: '#f44336',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '12px'
                            }}
                            title="Clear history data"
                        >
                            Clear History
                        </button>
                    )}
                </div>
                {displayDates.map((date, index) => {
                    const isLastUpdatedCol = showLastUpdatedCol && index === 0;
                    return (
                        <div
                            key={date.toISOString()}
                            style={{
                                padding: '10px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                backgroundColor: isLastUpdatedCol ? '#f5f5f5' : '#e3f2fd',
                                borderRadius: '4px'
                            }}
                        >
                            {formatDate(date)}
                        </div>
                    );
                })}

                <div style={{
                    gridColumn: `span ${displayDates.length + 1}`,
                    height: '2px',
                    backgroundColor: '#ddd'
                }}></div>

                {bedTypes.map((bed, bedIndex) => {
                    const key = getBedTypeKey(bed);
                    return (
                        <React.Fragment key={key}>
                            <div style={{ padding: '10px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                <span style={{ fontWeight: '500' }}>{bed.label}</span>
                                {bed.gender && <span style={{ fontSize: '12px', color: '#666' }}>({bed.gender})</span>}
                            </div>

                            {displayDates.map((_date, dateIndex) => {
                                const isLastUpdatedCol = showLastUpdatedCol && dateIndex === 0;
                                const availabilityIndex = showLastUpdatedCol ? dateIndex - 1 : dateIndex;

                                const value = isLastUpdatedCol
                                    ? lastUpdatedData?.beds[key] ?? ''
                                    : availability[availabilityIndex]?.beds[key] ?? '';

                                return (
                                    <input
                                        key={`${key}-${dateIndex}`}
                                        type="number"
                                        value={value}
                                        onChange={(e) => handleInputChange(key, dateIndex, e.target.value)}
                                        style={{
                                            padding: '8px',
                                            border: '1px solid #ddd',
                                            borderRadius: '4px',
                                            textAlign: 'center',
                                            backgroundColor: isLastUpdatedCol ? '#f5f5f5' : 'white'
                                        }}
                                        disabled={isLastUpdatedCol}
                                    />
                                );
                            })}
                            {(bedIndex === 1 || bedIndex === 3 || bedIndex === 4) && (
                                <div style={{
                                    gridColumn: `span ${displayDates.length + 1}`,
                                    height: '2px',
                                    backgroundColor: '#ddd'
                                }}></div>
                            )}
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
};

const FormSection6 = ({ inputData, handleChange, handleToggleChange, handleBrochureImgChange, handleListingLogoChange, editorRef }) => {
    const { care, clinical, beds, amenities, insurance } = useContext(OptionsContext)

    const capabilitiesArr = clinical.map(e => e.option)
    const insurances = insurance.map(e => e.option)
    const amenitiesArr = amenities.map(e => e.option)
    const careArr = care.map(e => e.option)
    const bedsArr = beds.map(e => e.option)

    return <>
        <h3 className="manage-facility-form-title">Input Specific Features</h3>

        <label htmlFor="phone">Description</label>
        <div>

            <Editor
                apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
                initialValue={inputData.long_description}
                onInit={(evt, editor) => editorRef.current = editor}
                // onEditorChange={(e) => handleChange({ target: { name: 'long_description', value: e } })}
                init={{
                    height: 500,
                    marginBottom: 10,
                    menubar: false,
                    plugins: [
                        // 'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                        // 'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                        // 'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                    ],
                    toolbar: 'undo redo | blocks | ' +
                        'bold italic forecolor | alignleft aligncenter ' +
                        'alignright alignjustify | bullist numlist outdent indent | ' +
                        'removeformat | help',
                    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                }}
            />
        </div>
        {/* <TextField
            name='long_description'
            className='manger-facility-input'
            multiline
            value={inputData.long_description}
            onChange={(e) => handleChange(e)}
        /> */}

        {/* <label htmlFor="phone">Rating</label>
        <div style={{ marginBottom: 10 }}>
            <Rating
                name="rating"
                value={inputData.rating}
                onChange={(e) => handleChange(e)}
            />
        </div> */}

        {/* <label htmlFor="total_beds">Number of Beds</label>
        <InputBase className='manger-facility-input' value={inputData.total_beds} onChange={(e) => handleChange(e)} type="number" name="total_beds" id="total_beds" placeholder='total number of beds' /> */}

        {/* <label htmlFor="semiprivate_beds">Number of SemiPrivate Beds</label>
        <InputBase className='manger-facility-input' value={inputData.semiprivate_beds} onChange={(e) => handleChange(e)} type="number" name="semiprivate_beds" id="semiprivate_beds" placeholder='semiprivate beds' /> */}

        <label htmlFor="state">Bed Types</label>
        <FormControl fullWidth>
            <Select
                multiple
                className="manger-facility-input"
                value={inputData.bed_types}
                name="bed_types"
                onChange={(e) => handleChange(e)}
            >
                {bedsArr.map(e => <MenuItem key={e} value={e}>{e}</MenuItem>)}
            </Select>
        </FormControl>

        <label htmlFor="state">Capabilities</label>
        <FormControl fullWidth>
            <Select
                multiple
                className="manger-facility-input"
                value={inputData.capabilities}
                name="capabilities"
                onChange={(e) => handleChange(e)}
            >
                {capabilitiesArr.map(e => <MenuItem key={e} value={e}>{e}</MenuItem>)}
            </Select>
        </FormControl>

        <label htmlFor="state">Amenities</label>
        <FormControl fullWidth>
            <Select
                multiple
                className="manger-facility-input"
                value={inputData.amenities}
                name="amenities"
                onChange={(e) => handleChange(e)}
            >
                {amenitiesArr.map(e => <MenuItem key={e} value={e}>{e}</MenuItem>)}
            </Select>
        </FormControl>

        <label htmlFor="state">Care Offered</label>
        <FormControl fullWidth>
            <Select
                multiple
                className="manger-facility-input"
                value={inputData.care}
                name="care"
                onChange={(e) => handleChange(e)}
            >
                {careArr.map(e => <MenuItem key={e} value={e}>{e}</MenuItem>)}
            </Select>
        </FormControl>

        <label htmlFor="state">Insurances Accepted</label>
        <FormControl fullWidth>
            <Select
                multiple
                className="manger-facility-input"
                value={inputData.insurance}
                name="insurance"
                onChange={(e) => handleChange(e)}
            >
                {insurances.map(e => <MenuItem key={e} value={e}>{e}</MenuItem>)}
            </Select>
        </FormControl>

        <label htmlFor="phone">Published / Unpublished</label>
        <div style={{ marginBottom: 10 }}>
            <FormControlLabel control={<Switch onChange={(e) => handleToggleChange(e)} value={inputData.published} name="published" />} label={inputData.published.toString()} />
        </div>

        {/* <label htmlFor="phone">Pet Friendly</label>
        <div style={{ marginBottom: 10 }}>
            <FormControlLabel control={<Switch onChange={(e) => handleToggleChange(e)} value={inputData.pet_friendly} name="pet_friendly" />} label={inputData.pet_friendly !== null && inputData.pet_friendly.toString()} />
        </div> */}

        {/* <label htmlFor="phone">Allow Smoking</label>
        <div style={{ marginBottom: 10 }}>
            <FormControlLabel control={<Switch onChange={(e) => handleToggleChange(e)} value={inputData.smoke_friendly} name="smoke_friendly" />} label={inputData.smoke_friendly !== null && inputData.smoke_friendly.toString()} />
        </div> */}


        {/* Brochure Image Section */}
        <label className="manage-facility-form-title">Add Brochure Image</label>
        <div style={{ marginBottom: 10 }}>
            <input onChange={(e) => handleBrochureImgChange(e)} accept="image/*" id="contained-button-file" multiple type="file" />
            <p>{inputData.brochure_image?.name}</p>
        </div>

        <label htmlFor="phone">Listing Logo</label>
        <div style={{ marginBottom: 10 }}>
            <input onChange={(e) => handleListingLogoChange(e)} accept="image/*" id="contained-button-file" multiple type="file" />
            <p>{inputData.listing_logo?.name}</p>
        </div>

        <label htmlFor="phone">Listing Color</label>
        <InputBase className='manger-facility-input' value={inputData.listing_color_primary} onChange={(e) => handleChange(e)} type="text" name="listing_color_primary" id="listing_color_primary" placeholder='Primary Color' />
        <InputBase className='manger-facility-input' value={inputData.listing_color_secondary} onChange={(e) => handleChange(e)} type="text" name="listing_color_secondary" id="listing_color_secondary" placeholder='Secondary Color' />

    </>
}